import { render } from "./Bunkai.vue?vue&type=template&id=938b90c4"
import script from "./Bunkai.vue?vue&type=script&lang=js"
export * from "./Bunkai.vue?vue&type=script&lang=js"
script.render = render

export default script